import React, { useState } from 'react';

import { Row, Col } from 'react-bootstrap';
import SkyPulseTable from 'components/SkyPulseTable';
import UsageFilter from '../UsageFilter';
import { getUTCShortDate } from 'utils';
import { WeekOptions, defaultUsageFilters } from 'constants';

import styles from './styles.module.css';

const columnDefinitions = [
  {
    name: 'Views',
    key: 'views',
    size: 'xsmall',
    dataCyClassName: 'Usage-MovingMapTableColumn-views',
  },
  {
    name: 'Avg view mins',
    key: 'avg_views_min',
    size: 'small',
    dataCyClassName: 'Usage-MovingMapTableColumn-avgViewsMin',
  },
  {
    name: 'Passenger pool %',
    key: 'passenger_pool_per',
    size: 'small',
    dataCyClassName: 'Usage-MovingMapTableColumn-passengerPoolPer',
  },
];

const data = [
  {
    views: {
      display: '194,322',
      sort: 194322,
    },
    avg_views_min: 88,
    passenger_pool_per: '44.1%',
  },
];

const MovingMap = () => {
  const [filters, setFilters] = useState(defaultUsageFilters);

  const week = WeekOptions[filters.week];
  const options = { month: 'short', day: 'numeric' };

  return (
    <Row className={styles.root} noGutters>
      <Col>
        <Row className={styles.title} noGutters>
          <Col data-cy-id="Usage-MovingMap-Header" className="title_1">
            Moving Map
          </Col>
        </Row>
        <Row noGutters>
          <UsageFilter
            showSearchBar={false}
            onFilterClick={(filters) => {
              setFilters(filters);
            }}
            onClear={(filters) => {
              setFilters(filters);
            }}
          />
        </Row>
        <Row className={styles.dataContainer} noGutters>
          <Col className="h-100">
            <Row className={styles.tableContainer} noGutters>
              <Col className="h-100">
                <SkyPulseTable
                  columns={columnDefinitions}
                  rows={data}
                  title={
                    <Row>
                      <Col>
                        {filters.option === 'week'
                          ? `Week of:
                          ${new Date(week?.startDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          -
                          ${new Date(week?.endDt).toLocaleDateString(
                            'en-US',
                            options,
                          )}
                          , ${new Date(week?.endDt).getFullYear()}`
                          : `Starting ${getUTCShortDate(
                              filters.startingDt,
                            )}, for ${filters.noOfDays} ${
                              filters.noOfDays === 1 ? 'day' : 'days'
                            }`}
                      </Col>
                      <Col md="auto">
                        Pool: <b>500,145</b> passengers used system
                      </Col>
                    </Row>
                  }
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default MovingMap;
